import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatIconButton} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatSortModule} from '@angular/material/sort';
import {MatTreeModule} from '@angular/material/tree';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NbEvaIconsModule} from '@nebular/eva-icons';
import {NbRoleProvider, NbSecurityModule} from '@nebular/security';
import {NbActionsModule, NbAlertModule, NbAutocompleteModule, NbButtonModule, NbCardModule, NbCheckboxModule, NbDialogModule, NbIconModule, NbInputModule, NbLayoutModule, NbListModule, NbMenuModule, NbSelectModule, NbSidebarModule, NbSpinnerModule, NbTabsetModule, NbTagModule, NbThemeModule, NbTooltipModule, NbWindowModule} from '@nebular/theme';
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap';
import {RoleProviderService} from 'compob2b-auth';
import {CheckboxPropertyComponent, CompoTreeComponent, FileUploadComponent, FilterCountComponent, InputFilterPropertyComponent, IntervalWrapperComponent, SelectFilterPropertyComponent, SharedModule, UploaderComponent} from 'compob2b-libs';
import {environment} from '../../environments/environment';
import {ACL_OPTIONS} from '../security';
import {BreadcrumbsModule} from './breadcrumbs/breadcrumbs.module';
import {CabinetRoutingModule} from './cabinet.routing.module';
import {CartModule} from './cart/cart.module';
import {CatalogModule} from './catalog/catalog.module';
import {ProductModule} from './product/product.module';

import {LayoutComponent} from './shared/layout/layout.component';
import {PopupCompanyComponent} from './shared/modal-company/modal-company.component';
import {ModalExcelExportComponent} from './shared/modal-excel-export/modal-excel-export.component';
import {ModalLocationComponent} from './shared/modal-location/modal-location.component';
import {ModalMenuComponent} from './shared/modal-menu/modal-menu.component';
import {PageLinkComponent} from './shared/page-link/page-link.component';
import {FormlyModule} from "@ngx-formly/core";
import {FilterComponent} from "./filter-component/filter.component";
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {SearchAutocompleteComponent} from "./search-autocomplete/search-autocomplete.component";
import {HeaderMobileComponent} from "./shared/header-mobile/header-mobile.component";
import {FooterMobileComponent} from "./shared/footer-mobile/footer-mobile.component";

@NgModule({
  declarations: [
    LayoutComponent,
    ModalMenuComponent,
    PopupCompanyComponent,
    ModalLocationComponent,
    PageLinkComponent,
    ModalExcelExportComponent
  ],

  imports: [
    CommonModule,
    MatTreeModule,
    BrowserAnimationsModule,
    BreadcrumbsModule,
    MatSortModule,
    CabinetRoutingModule,
    SharedModule.forRoot(environment),
    NbThemeModule.forRoot({name: 'default'}),
    NbButtonModule,
    FormlyModule.forRoot({
      wrappers: [
        {name: 'interval-wrapper', component: IntervalWrapperComponent},
      ],
      types: [
        {name: 'checkbox', component: CheckboxPropertyComponent},
        {name: 'input-filter-property', component: InputFilterPropertyComponent},
        {name: 'select-filter-property', component: SelectFilterPropertyComponent},
        {name: 'select-multi-filter-property', component: SelectFilterPropertyComponent},
        {name: 'file-upload-input', component: FileUploadComponent},
      ],
      validationMessages: SharedModule.validationMessages(),
    }),
    NbLayoutModule,
    NbActionsModule,
    NbInputModule,
    NbEvaIconsModule,
    NbSecurityModule.forRoot(ACL_OPTIONS),
    NbMenuModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbTooltipModule,
    NbIconModule,
    NbCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    NbCheckboxModule,
    NbSelectModule,
    NbListModule,
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbTagModule,
    NbAlertModule,
    NbSpinnerModule,
    NbAutocompleteModule,
    NbTabsetModule,
    FormlyBootstrapModule,
    CatalogModule,
    ProductModule,
    CartModule,
    NbSecurityModule,
    NbMenuModule,
    NbSidebarModule,
    MatIconButton,
    FilterCountComponent,
    CompoTreeComponent,
    FormlyModule,
    MatMenu,
    MatMenuTrigger,
    MatMenuItem,
    UploaderComponent,
    SearchAutocompleteComponent,
    HeaderMobileComponent,
    FooterMobileComponent,
    FilterComponent,
  ],
  exports: [
    MatTreeModule,
  ],
  providers: [
    {
      provide: NbRoleProvider,
      useClass: RoleProviderService,
    }
  ],
})
export class CabinetModule {
}
